import { useState, useEffect } from 'react'

export const useScrollVisible = (wrapper?: React.MutableRefObject<HTMLDivElement>) => {
  const [scrollVisible, setScrollVisible] = useState(false)

  useEffect(() => {
    if (wrapper) {
      const wrapperHeight = wrapper?.current?.clientHeight
      setScrollVisible(wrapperHeight < wrapper?.current?.scrollHeight)
    }
  }, [wrapper])

  return scrollVisible
}
